import { useTranslation } from 'react-i18next';

import { VFlex } from '@/package';

import { APIKeyCreationButton } from './APIKeyCreationButton';

export const APIKeyListPageOverview = () => {
  const { t } = useTranslation();
  return (
    <VFlex className="py-4" items="center" justify="between">
      <div
        className="py-4 text-body-xl leading-[26px] whitespace-pre-line text-blue-300"
        dangerouslySetInnerHTML={{
          __html: t('apiKey.pageOverviewDescription.redstreak'),
        }}
      />

      <APIKeyCreationButton />
    </VFlex>
  );
};

APIKeyListPageOverview.displayName = 'APIKeyListPageOverview';
